import type { MapFeedItemDTO } from "../../data/types";

/**
 * Vilka lägen som förtjänar en pin. Speglar MAP_VISIBLE_STATUSES i
 * api/venueStatus.js, där också tidsgränserna för varje status bor.
 *
 * Klienten litar inte på att servern redan har filtrerat: ett äldre API, ett
 * cachat svar eller en halv deploy ska inte kunna måla ut barer som inte
 * spelar något.
 */
export const VISIBLE_MAP_STATUSES = new Set(["LIVE", "RECENT", "TODAY"]);

export function isVenueVisibleOnMap(item: MapFeedItemDTO) {
  if (!item?.venue) return false;

  // Ställen utan live-data har inget flöde att vara färskt. De finns på
  // riktigt och ska gå att hitta, så de ritas alltid — som gråa pins.
  if (item.hasLiveData === false) return true;

  // Med live-data gäller samma regel som förut.
  if (!item.nowPlaying) return false;

  return VISIBLE_MAP_STATUSES.has(item.status);
}

/** True när stället inte har något live-flöde att visa. */
export function lacksLiveData(item: MapFeedItemDTO) {
  return item?.hasLiveData === false;
}

export function hasVenueCoords(
  item: MapFeedItemDTO
): item is MapFeedItemDTO & { venue: { lat: number; lon: number } } {
  return Number.isFinite(item.venue.lat) && Number.isFinite(item.venue.lon);
}
